import { GenericMessage } from "./GenericMessage";
export const ReadyMessage = new GenericMessage({ command: 'SEND DATA' });
